module.exports = __webpack_public_path__ + "img/close.f104bcf6.svg";